import type { Album, DefaultResponseBody, ListResponseBody, Song } from "@gerama/types";
import type { ApiClient } from "../client";

export function createCoreAlbumsApi(client: ApiClient) {
  return {
    list: (
      params: { page?: number; limit?: number; artistId?: number } = {},
      signal?: AbortSignal,
    ) =>
      client
        .request<ListResponseBody<Album>>("/albums", { query: { ...params }, signal })
        .then((res) => res.data ?? { list: [], count: 0 }),

    detail: (id: number | string, signal?: AbortSignal) =>
      client
        .request<DefaultResponseBody<Album>>(`/albums/${id}`, { signal })
        .then((res) => res.data as Album),

    songs: (id: number | string, params: { page?: number; limit?: number } = {}, signal?: AbortSignal) =>
      client
        .request<ListResponseBody<Song>>(`/albums/${id}/songs`, { query: { ...params }, signal })
        .then((res) => res.data ?? { list: [], count: 0 }),
  };
}
